import { Box, Typography } from "@mui/material";
import { FC } from "react";

import ClosedChatsHintRow from "./ClosedChatsHintRow";

interface NoChatsContentMessageProps {
  title?: string;
  subtitle?: string;
  /** Show the filters hint below the message, since the list may only be
   * empty because closed chats are hidden. */
  showClosedChatsHint?: boolean;
}

export const NoChatsContentMessage: FC<NoChatsContentMessageProps> = ({
  title,
  subtitle,
  showClosedChatsHint,
}) => {
  const hint = showClosedChatsHint ? <ClosedChatsHintRow /> : null;

  if (!title && !subtitle) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography sx={{ px: 2, textAlign: "center", pt: 1 }}>
          No chats to display!
        </Typography>
        {hint}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      {title ? (
        <Typography sx={{ px: 2, pt: 1, fontWeight: "bold" }}>
          {title}
        </Typography>
      ) : null}

      {subtitle ? (
        <Typography
          sx={{
            px: 2,
            fontSize: "13px",
            mt: 0.5,
            fontStyle: "italic",
            color: "text.secondary",
          }}
        >
          {subtitle}
        </Typography>
      ) : null}

      {hint}
    </Box>
  );
};
